<script>
import Cleave from "vue-cleave-component";
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import { scroller } from "vue-scrollto/src/scrollTo";
import { ref } from 'vue';
import clientConfig from '/src/config/client';

import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBBtnGroup,
  MDBTooltip
} from "mdb-vue-ui-kit";

import LifetimeSliderInput from '@lifetime-gallagher/lifetime-slider-input'

// import {
//   ValidationProvider,
//   ValidationObserver,
//   configure,
//   extend
// } from "vee-validate";

// import { required } from "vee-validate/dist/rules";

// configure({
//   classes: {
//     invalid: "is-invalid"
//   }
// });

// extend("required", {
//   ...required,
//   message: "This field is required"
// });

export function debounce(fn, delay) {
  var timeoutID = null;
  return function () {
    clearTimeout(timeoutID);
    var args = arguments;
    var that = this;
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay);
  }
}

export default {
  name: 'QuotePanel',
  components: {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBBtn,
    MDBBtnGroup,
    MDBTooltip,

    LifetimeSliderInput,
    Cleave

    //ValidationProvider,
    //ValidationObserver
  },

  setup() {
    const tooltip1 = ref(false);
    const tooltip2 = ref(false);
    return {
      tooltip1,
      tooltip2
    }
  },

  computed: {
    ...mapFields([
      "age",
      "insuranceType",
      "coverAmount",
      "premiumVariables",
    ]),
    ...mapGetters([
      "debugMode",
      "data"
    ])
  },

  methods: {
    clickToTab(tabNum) {
      const scrollTo = scroller();
      this.$store.commit("setActiveTab", tabNum);
      scrollTo("#iqApp");
      this.triggerHeightCheck();
      this.$gtag.event('click', {
        'event_category': 'navigation',
        'event_label': 'navigateTo' + tabNum,
        'value': 1
      });
      if (this.debugMode)
        console.log("GTAG Event: navigateTo" + tabNum);
    },

    printCalculation() {
      this.$gtag.event('click', {
        'event_category': 'navigation',
        'event_label': 'printResults',
        'value': 1
      });
      if (this.debugMode)
        console.log("GTAG Event: printResults");
      window.print();
    },

    toggleInsurance(vType) {
      this.insurance_tpd = vType === "deathTPD";
      this.$store.commit("updateInsuranceType", vType);
      
      // Update Slider maximums
      // Update Label
      if (vType === "deathTPD") {
        this.minCoverAmount = this.data.params.minDeathTPD;
        this.maxCoverAmount = this.data.params.maxDeathTPD;
        this.$store.commit("updateModellerName", "Death and Total & Permanent Disability (TPD) Cover");
      } else {
        this.minCoverAmount = this.data.params.minDeathOnly;
        this.maxCoverAmount = this.data.params.maxDeathOnly;
        this.$store.commit("updateModellerName", "Death Cover");
      }
      this.$store.commit("updateCoverAmount", Math.min(Math.max(this.coverAmount, this.minCoverAmount), this.maxCoverAmount));
    },

    toggleInsuranceBtn(e) {
      if(e.target.value) {
        this.toggleInsurance(e.target.value);
      } else {
        this.toggleInsurance(e.target.parentElement.value);
      }
    },

    vlookup(dataArr, inputAge, returnAsObj = false) {
      // OLD METHOD WITH LOCAL DATA
      if (this.data.params.calculationMethod === 'supersa') {
        if (dataArr === undefined || this.dataArr === null) {
          return false;
        } else {
          // this calc - lets loop thru till we get the age we want
          for (var i = 0; i < dataArr.length; i++) {
            if (dataArr[i].age === inputAge) {
              // Now we've gone past it - get the previous row's rate
              // console.log('age: ', inputAge, 'rate: ', dataArr[i].rate);
              if (returnAsObj) {
                return {
                  rate: dataArr[i].rate ? dataArr[i].rate : null,
                  value:  dataArr[i].value ? dataArr[i].value : null
                };
              } else {
                return dataArr[i].rate;
              }
            }
          }
          // we should always be able to find the rate that matches the year between age 15-69
          // Show the last value we have, make sure other checks are in place to ensure it is valid
          // return dataArr[dataArr.length - 1].rate;
          // or
          // return false;
        }
      // NEW METHOD CALLING API
      } else if (this.data.params.calculationMethod === 'visionsuper') {
        if (this.premiumVariables) {
          // Loop through data in ascending order, until we find the closest value
          console.log('dataArr', dataArr, 'inputAge', inputAge)
          for (i = 0; i < dataArr.length; i++) {
            if (dataArr[i].age === inputAge) {
              // Now we've gone past it - get the previous row's rate
              if (returnAsObj) {
                return {
                  rate: dataArr[i].rate ? dataArr[i].rate : null,
                  value:  dataArr[i].value ? dataArr[i].value : null
                };
              } else {
                console.log('rate:', dataArr[i].rate)
                return dataArr[i].rate;
              }
            }
          }
        }
      }
      return false;      
    },

    setDefaults() {
      this.typedAge = parseInt(this.age);

      if (this.insuranceType === null || this.insuranceType.length < 1) {
        this.toggleInsurance("deathTPD");
      } else {
        this.toggleInsurance(this.insuranceType);
      }
    },

    formatCurrency: (value, noCents = false) => {
      return value === null
        ? ""
        : noCents
        ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        : parseFloat(value)
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    reCalculate() {
      this.showCalculation = false;
      const scrollTo = scroller();
      scrollTo("#iqApp");
    },
  
    runCalculation() {
      let ageBasedCoverRate = 0;
      //let ageBasedCoverAmount = 0;
      let ageBasedCostPerYear = 0;
      let coverAmountRound = 0;
      let fixedWeeklyRate = 0;
      let weeksPerYear = 0;
      let i = 0;
      let j = 0;
      let _rate = 0;
      let _cover = 0;
      let _fixedrate = 0;
      let _weeklyAmount = 0;
      let _yearlyAmount = 0;
      let data = null;
      let fixedData = null;

      if (this.data.params.calculationMethod === 'visionsuper') { ///////////////////////////////////////////////////
        weeksPerYear = 52.14;

        // aged based cover amount and units
        ageBasedCoverRate = this.vlookup(this.premiumVariables.deathTPD.TPDUnits, this.age);
        this.units = Math.ceil(this.coverAmount / ageBasedCoverRate);
        this.ageBasedCoverAmount = ageBasedCoverRate * this.units;

        // aged based cover weekly amount
        this.ageBasedPeriodAmount = this.units * this.data.quoteData.unitCover[this.insuranceType + 'Premium'];
        ageBasedCostPerYear = weeksPerYear * this.units * this.data.quoteData.unitCover[this.insuranceType + 'Premium'];

        // aged based cover chart values
        this.ageBasedCoverChart = [];
        for (i = 1; i <= 5 && (this.age + i) < 70; i++) {
          _rate = this.vlookup(this.premiumVariables.deathTPD.TPDUnits, this.age + i);
          _cover = _rate * this.units;
          
          data = {
            "year": i,
            "cover": _cover,
            "costPerPeriod": this.ageBasedPeriodAmount,
            "costPerYear": ageBasedCostPerYear
          }

          this.ageBasedCoverChart.push(data);
        }

        // Fixed cover amount
        // round up cover amount
        coverAmountRound = Math.ceil(this.coverAmount / 1000);
        this.fixedCoverAmount = coverAmountRound * 1000;
        // fixedWeeklyAmount
        fixedWeeklyRate = this.vlookup((this.premiumVariables.deathTPD[this.insuranceType == 'deathTPD' ? 'TPDPremium' : (this.insuranceType + 'Premium')].male), this.age);
        this.fixedWeeklyAmount = coverAmountRound * fixedWeeklyRate  / weeksPerYear;

        // fixed cover chart values
        this.fixedCoverChart = [];
        for(j = 1; j <= 5 && (this.age + j) < 70; j++) {
          _fixedrate = this.vlookup(this.premiumVariables.deathTPD[this.insuranceType == 'deathTPD' ? 'TPDPremium' : (this.insuranceType + 'Premium')].male, this.age + j);
          _weeklyAmount = coverAmountRound * _fixedrate / weeksPerYear;
          _yearlyAmount = coverAmountRound * _fixedrate;

          fixedData = {
            "year": j,
            "cover": this.fixedCoverAmount,
            "costPerPeriod": _weeklyAmount,
            "costPerYear": _yearlyAmount
          }
          this.fixedCoverChart.push(fixedData);
        }

        //------------------------
        this.$gtag.event('data', {
          'event_category': 'userInput',
          'event_label': 'userAge' + this.age,
          'value': 1
        });
        if (this.debugMode)
          console.log("GTAG Event: userAge" + this.age);
        //------------------------
        this.$gtag.event('data', {
          'event_category': 'userInput',
          'event_label': 'insuranceType' + (this.insuranceType === "deathTPD" ? "DeathTPD" : "DeathOnly"),
          'value': 1
        });
        if (this.debugMode)
          console.log("GTAG Event: insuranceType" + (this.insuranceType === "deathTPD" ? "DeathTPD" : "DeathOnly"));
        //------------------------
        this.$gtag.event('data', {
          'event_category': 'userInput',
          'event_label': 'coverAmount' + this.coverAmount,
          'value': 1
        });
        if (this.debugMode)
          console.log("GTAG Event: coverAmount" + this.coverAmount);
        //------------------------

      } else if (this.data.params.calculationMethod === 'supersa') { ///////////////////////////////////////////////////
        weeksPerYear = (313 / 6); //= 52.16;
        let vLookupResult = null;

        // DEATH & TPD / DEATH ONLY
        this.ageBasedPeriodPremium = this.data.quoteData.unitCover[this.insuranceType + 'Premium'];
        // Value of units
        this.fixedPeriodCover = this.data.quoteData.fixedCover[this.insuranceType + 'Value'];

        // STANDARD / UNIT / AGE BASED
        vLookupResult = this.vlookup(this.data.quoteData.unitCover[this.insuranceType], this.age, true);
        if (this.debugMode)
          console.log("unitCover Type:", this.insuranceType, "Age:", this.age, " =", vLookupResult.value);

        this.units = Math.ceil(this.coverAmount / vLookupResult.value);
        if (this.debugMode)
          console.log("Standard Units =", this.units, " -> ", this.coverAmount, " / ", vLookupResult.value);
        
        this.ageBasedCoverAmount = this.units * vLookupResult.value;
        if (this.debugMode)
          console.log("Standard Cover Amount =", this.ageBasedCoverAmount, " -> ", this.units, " * ", vLookupResult.value);
        
        this.ageBasedPeriodAmount = (this.units * this.ageBasedPeriodPremium);
        if (this.debugMode)
          console.log("Standard Period Amount =", this.ageBasedPeriodAmount, " -> ", this.units, " * ", this.ageBasedPeriodPremium);
        
        // AGE BASED cover chart data
        this.ageBasedCoverChart = [];

        for (i = 1; i <= 5 && (this.age + i) < 70; i++) {
          vLookupResult = this.vlookup(this.data.quoteData.unitCover[this.insuranceType], this.age + i, true);
          _cover = vLookupResult.value * this.units;
          
          data = {
            "year": i,
            "cover": _cover,
            "costPerPeriod": this.ageBasedPeriodAmount,
            "costPerYear": this.ageBasedPeriodAmount * weeksPerYear
          }

          this.ageBasedCoverChart.push(data);
        }

        // FIXED
        vLookupResult = this.vlookup(this.data.quoteData.fixedCover[this.insuranceType], this.age, true);
        if (this.debugMode)
          console.log("fixedCover Type:", this.insuranceType, "Age:", this.age, " =", vLookupResult.rate);

        this.fixedUnits = Math.ceil(this.coverAmount / this.fixedPeriodCover);
        if (this.debugMode)
          console.log("Fixed Units =", this.fixedUnits, " -> ", this.coverAmount, " / ", this.fixedPeriodCover);

        this.fixedWeeklyAmount = vLookupResult.rate * this.fixedUnits;
        if (this.debugMode)
          console.log("Fixed Weekly Amount =", this.fixedWeeklyAmount, " -> ", vLookupResult.rate, " * ", this.fixedUnits);

        this.fixedCoverAmount = this.fixedPeriodCover * this.fixedUnits;
        if (this.debugMode)
          console.log("Fixed Cover Amount =", this.fixedCoverAmount, " -> ", this.fixedPeriodCover, " * ", this.fixedUnits);

        // FIXED cover chart data
        this.fixedCoverChart = [];

        for (j = 1; j <= 5 && (this.age + j) < 70; j++) {
          vLookupResult = this.vlookup(this.data.quoteData.fixedCover[this.insuranceType], this.age + j, true);
          _weeklyAmount = vLookupResult.rate * this.fixedUnits;

          fixedData = {
            "year": j,
            "cover": this.fixedCoverAmount,
            "costPerPeriod": _weeklyAmount,
            "costPerYear": _weeklyAmount * weeksPerYear
          }
          this.fixedCoverChart.push(fixedData);
        }

        //------------------------
        this.$gtag.event('data', {
          'event_category': 'userInput',
          'event_label': 'userAge' + this.age,
          'value': 1
        });
        if (this.debugMode)
          console.log("GTAG Event: userAge" + this.age);
        //------------------------
        this.$gtag.event('data', {
          'event_category': 'userInput',
          'event_label': 'insuranceType' + (this.insuranceType === "deathTPD" ? "DeathTPD" : "DeathOnly"),
          'value': 1
        });
        if (this.debugMode)
          console.log("GTAG Event: insuranceType" + (this.insuranceType === "deathTPD" ? "DeathTPD" : "DeathOnly"));
        //------------------------
        this.$gtag.event('data', {
          'event_category': 'userInput',
          'event_label': 'coverAmount' + this.coverAmount,
          'value': 1
        });
        if (this.debugMode)
          console.log("GTAG Event: coverAmount" + this.coverAmount);
        //------------------------

      } else { /////////////////////////////////////////////////////////////////////////////////////////////////////////
        console.log("Error: Invalid calculation configuration.")
      }

      this.showCalculation = true;
      const scrollTo = scroller();
      scrollTo("#iqApp");
      this.triggerHeightCheck();
    },

    triggerHeightCheck() { 
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function() {
        rf.$refreshIframeHeight();
      }, 300);
    },
  },

  mounted() {
    this.setDefaults();
    this.triggerHeightCheck();
    window.addEventListener("resize", this.$refreshIframeHeight);
  },

  unmounted() {
    window.removeEventListener("resize", this.$refreshIframeHeight);
  },

  watch: {
    typedAge: debounce(function (newVal) {
      this.typedAge_ = newVal;
    }, 1300),

    typedAge_(newAge) {
      if (typeof newAge === "string") {
        newAge = parseInt(newAge);
      }
      if (newAge !== this.age) {
        if (newAge < 15) {
          newAge = 15;
        } else if (newAge > 69) {
          newAge = 69;
        }
        this.typedAge = newAge;
        this.$store.commit("updateAge", newAge);
      }
    },

    age(newAge) {
      if (typeof newAge === "string") {
        newAge = parseInt(newAge);
      }
      if (newAge !== this.typedAge) {
        if (newAge < 15) {
          newAge = 15;
        } else if (newAge > 69) {
          newAge = 69;
        }
        this.typedAge = newAge;
      }
    }
  },
  
  data() {
    return {
      clientConfig,
      showCalculation: false,
      typedAge: null,
      typedAge_: null,
      minCoverAmount: 8000,
      maxCoverAmount: 2500000,
      formatOptions: {
        salary: {
          numeral: true,
          prefix: "$",
          numeralPositiveOnly: true,
          noImmediatePrefix: true,
          rawValueTrimPrefix: true,
          numeralIntegerScale: 9,
          numeralDecimalScale: 2
        },
        number: {
          numericOnly: true,
          blocks: [2]
        }
      },
      insurance_tpd: false,
      ageBasedCoverAmount: null,
      ageBasedPeriodAmount: null,
      ageBasedPeriodPremium: null,
      ageBasedPeriodPremium2: null,
      fixedPeriodCover: null,
      fixedCoverAmount: null,
      fixedWeeklyAmount: null,
      units: null,
      fixedUnits: null,
      ageBasedCoverChart: [],
      fixedCoverChart: [],
    }
  }
}
</script>

<template>
  <MDBContainer fluid>
    <MDBRow class="p-0" v-if="!showCalculation">
      <MDBCol 
        col="12"
        class="p-3 ps-4 pe-5 text-start bg-darker icon-shieldman-lg"
      >
        <h4 class="pe-5" v-html="clientConfig.content.calculation.header"></h4>
      </MDBCol>
    </MDBRow>

    <MDBRow class="p-0" v-if="showCalculation">
      <MDBCol 
        col="12"
        class="p-3 bg-light-cyan d-flex justify-content-center"
      >
        <div class="text-center">
          {{ clientConfig.content.calculation.resultsIntro }} <strong>{{ insurance_tpd ? 'Death &amp; TPD' : 'Death' }} Cover</strong> for
          <br />
          <span class="big-result">
            ${{ formatCurrency(coverAmount, true) }}
          </span>
        </div>
      </MDBCol>

      <MDBCol 
        col="12"
        lg="6"
        class="p-3 d-flex justify-content-center result-card"
      >
        <div class="align-self-top mid-bg result-card-wrapper text-center">
          <h2>
            {{ clientConfig.content.calculation.ageBasedCoverHeading }}
          </h2>
          <small>{{ insurance_tpd ? 'Death &amp; TPD' : 'Death only' }}</small>
          <br />
          <MDBRow class="row">
            <MDBCol 
              col="6"
            >
              {{ clientConfig.content.calculation.ageBasedCoverCoverLabel }}
              <br/>
              ${{ formatCurrency(ageBasedCoverAmount, true) }}
              <br/>
              ({{ units }} units)
            </MDBCol>
            <MDBCol 
              col="6"
            >
              {{ clientConfig.content.calculation.ageBasedCoverCostLabel }}
              <br/>
              ${{ formatCurrency(ageBasedPeriodAmount, false) }}
              <span v-html="clientConfig.content.calculation.ageBasedCoverPerPeriod"></span>
            </MDBCol>
          </MDBRow>
          <br />
          <small class="desc" v-html="clientConfig.content.calculation.ageBasedCoverText">
          </small>
          <div 
            class="bg-mid-cyan justify-content-center result-card-lower" 
            v-if="ageBasedCoverChart.length > 0"
          >
            <h3>{{ clientConfig.content.calculation.yoyChangesHeading }}</h3>
            <br />
            <table class="yoytbl">
              <tr>
                <th>Age</th>
                <th>Cover</th>
                <th>{{ clientConfig.content.calculation.ageBasedCoverTableColPerPeriod }}</th>
                <th>Per Year</th>
              </tr>
              <tr v-for="(item, indx) in ageBasedCoverChart" :key="indx">
                <td>{{parseInt(typedAge) + item.year}}</td>
                <td width="30%">${{formatCurrency(item.cover, true)}}</td>
                <td width="28%">${{formatCurrency(item.costPerPeriod, false)}}</td>
                <td width="30%">${{formatCurrency(item.costPerYear, false)}}</td>
              </tr>
            </table>
          </div>
        </div>
      </MDBCol>

      <MDBCol 
        col="12"
        lg="6"
        class="p-3 d-flex justify-content-center result-card"
      >
        <div class="align-self-top mid-bg result-card-wrapper text-center">
          <h2>
            {{ clientConfig.content.calculation.fixedCoverHeading }}
          </h2>
          <small>{{ insurance_tpd ? 'Death &amp; TPD' : 'Death only' }}</small>
          <br />
          <MDBRow class="row">
            <MDBCol 
              col="6"
            >
              {{ clientConfig.content.calculation.fixedCoverCoverLabel }}
              <br/>
              ${{ formatCurrency(fixedCoverAmount, true) }}
              <span v-if="clientConfig.content.calculation.unitisedFixedCover">
                <br/>
                ({{ fixedUnits }} units)
              </span>
            </MDBCol>
            <MDBCol 
              col="6"
            >
              {{ clientConfig.content.calculation.fixedCoverCostLabel }}
              <br/>
              ${{ formatCurrency(fixedWeeklyAmount, false) }}
              <span v-html="clientConfig.content.calculation.fixedCoverPerPeriod"></span>
            </MDBCol>
          </MDBRow>
          <br />
          <small class="desc" v-html="clientConfig.content.calculation.fixedCoverText">
          </small>
          <div 
            class="bg-mid-cyan result-card-lower" 
            v-if="fixedCoverChart.length > 0"
          >
            <h3>{{ clientConfig.content.calculation.yoyChangesHeading }}</h3>
            <br />
            <table class="yoytbl">
              <tr>
                <th>Age</th>
                <th>Cover</th>
                <th>{{ clientConfig.content.calculation.fixedCoverTableColPerPeriod }}</th>
                <th>Per Year</th>
              </tr>
              <tr v-for="(item, indx) in fixedCoverChart" :key="indx">
                <td width="12%">{{parseInt(typedAge) + item.year}}</td>
                <td width="30%">${{formatCurrency(item.cover, true)}}</td>
                <td width="28%">${{formatCurrency(item.costPerPeriod, false)}}</td>
                <td width="30%">${{formatCurrency(item.costPerYear, false)}}</td>
              </tr>
            </table>
          </div>
        </div>
      </MDBCol>
    </MDBRow>

    <!-- <ValidationObserver ref="observer" class="w-100"> -->
    <MDBRow class="p-0 pb-3 bg-light-grey" v-if="!showCalculation">
      <MDBCol 
        col="12"
        lg="8"
        class="pt-4 text-start mx-auto"
      >
        <MDBRow class="p-0">
          <MDBCol col="2" lg="1" class="text-start pt-0">
            <div class="main-icon ms-lg-0">
              <div class="icon-person"></div>
            </div>
          </MDBCol>
          <MDBCol col="10" lg="11" class="text-start pt-2 pb-1">
            <div class="form-group">
              <div class="input-holder">
                <label for="ageSlider" tabindex="0" id="age_label">
                  {{ clientConfig.content.calculation.ageLabel }}
                </label>
                <cleave
                  v-model="typedAge"
                  :options="formatOptions.number"
                  name="typedAge"
                  type="text"
                  id="typedAge"
                  class="form-control mini-input"
                  tabindex="0"
                  aria-labelledBy="age_label"
                ></cleave>
              </div>
              <LifetimeSliderInput
                :min="15"
                :max="69"
                v-model="age"
                :tooltips="false"
              />
            </div>
          </MDBCol>
        </MDBRow>

        <MDBRow class="p-0 pt-3">
          <MDBCol col="2" lg="1" class="text-left pt-0">
            <div class="main-icon ms-lg-0">
              <div class="icon-shield"></div>
            </div>
          </MDBCol>

          <MDBCol col="10" lg="11" class="text-left pt-2">
            <div class="form-group pt-1">
              <MDBTooltip 
                v-model="tooltip1"
                boundary="#iqApp"
                direction="top"
              >
                <template #reference>
                  <span class="icon-info"></span>
                </template>
                <template #tip>
                  <span>
                    {{ clientConfig.content.calculation.insuranceTypeTooltip }}
                  </span>
                </template>
              </MDBTooltip>

              <label 
                for="insuranceType" 
                id="insuranceType_label" 
                class="pb-3" tabindex="0"
              >
                {{ clientConfig.content.calculation.insuranceTypeLabel }}
              </label>
              <!-- <ValidationProvider name="insuranceTypeValidation"> -->
                <input
                  type="hidden"
                  name="insurance"
                  id="insuranceType"
                  :value="insuranceType"
                />
              <!-- </ValidationProvider> -->
              <br />
              <MDBBtnGroup 
                class="multi-select-group shadow-0"
                role="radiogroup" 
                aria-labelledby="insuranceType_label"
              >
                <MDBBtn
                  color="default"
                  class="multi-select"
                  value="deathOnly"
                  @click="toggleInsuranceBtn"
                  :class="!insurance_tpd ? 'active' : ''"
                  role="radio"
                  tabindex="0" 
                  aria-label="Death cover only"
                  v-html="clientConfig.content.calculation.deathOnlyButtonLabel"
                >
                </MDBBtn>
                <MDBBtn
                  color="default"
                  class="multi-select"
                  value="deathTPD"
                  @click="toggleInsuranceBtn"
                  :class="insurance_tpd ? 'active' : ''"
                  role="radio"
                  tabindex="0" 
                  aria-label="Death &amp; TPD cover"
                  v-html="clientConfig.content.calculation.deathTpdButtonLabel"
                >
                </MDBBtn>
              </MDBBtnGroup>
            </div>
          </MDBCol>
        </MDBRow>

        <MDBRow class="p-0 pt-3">
          <MDBCol col="2" lg="1" class="text-start pt-0">
            <div class="main-icon ms-lg-0">
              <div class="icon-dollars"></div>
            </div>
          </MDBCol>
          <MDBCol col="10" lg="11" class="text-start pt-2 pb-1">
            <div class="form-group">
              <MDBTooltip 
                v-model="tooltip2"
                boundary="#iqApp"
                direction="top"
              >
                <template #reference>
                  <span class="icon-info"></span>
                </template>
                <template #tip>
                  <span>
                    {{ clientConfig.content.calculation.coverAmountTooltip }}
                  </span>
                </template>
              </MDBTooltip>

              <label for="coverSlider" tabindex="0" id="coverAmount_label">
                {{ clientConfig.content.calculation.coverAmountLabel }}
              </label>
              <div class="big-result off-center text-center" tabindex="0">
                ${{ formatCurrency(coverAmount, true) }}
              </div>
              <LifetimeSliderInput
                :min='minCoverAmount'
                :max='maxCoverAmount'
                :step='2000'
                v-model='coverAmount'
                :tooltips="false"
              />
            </div>
          </MDBCol>
        </MDBRow>
      </MDBCol>
    </MDBRow>
    <!-- </ValidationObserver> -->

    <MDBRow class="p-0" v-if="!showCalculation">
      <MDBCol 
        col="11"
        class="p-2 pt-3 pb-3 pt-md-4 pb-md-4 mx-auto text-center"
      >
        <MDBBtn
          color="primary"
          class="rounded"
          @click="runCalculation"
          tabindex="0"
          aria-label="Calculate button"
        >
          {{ clientConfig.content.calculation.calculateButtonLabel }}
        </MDBBtn>
      </MDBCol>
    </MDBRow>

    <MDBRow class="p-0" v-if="showCalculation">
      <MDBCol 
        col="12"
        md="8"
        class="p-3 pt-3 pt-md-4 pb-md-4 text-center text-md-start"
      >
        <MDBBtn
          color="primary"
          class="rounded half"
          @click="printCalculation"
          aria-label="Print button"
          tabindex="0"
        >
          {{ clientConfig.content.calculation.printButtonLabel }}
        </MDBBtn>

        <MDBBtn
          outline="primary"
          class="rounded ms-3"
          @click="reCalculate"
          tabindex="0"
          aria-label="Recalculate button"
        >
          {{ clientConfig.content.calculation.reCalculateButtonLabel }}
        </MDBBtn>
      </MDBCol>

      <MDBCol 
        col="12"
        md="4"
        class="p-3 pt-2 pt-md-4 pb-md-4 text-center text-md-end"
      >
        <MDBBtn
          color="primary"
          class="rounded"
          @click="clickToTab(3)"
          tabindex="0"
          aria-label="Next button"
        >
          {{ clientConfig.content.calculation.nextButtonLabel }}
        </MDBBtn>
      </MDBCol>
    </MDBRow>
  </MDBContainer>
</template>
